import React from 'react';
import { Route, Switch } from 'react-router-dom';

import UserLayout from '../../layouts/UserLayout';

import Login from './login';

export default function index({ match }) {
  return (
    <UserLayout>
      <Switch>
        <Route exact path={`${match.url}`} component={Login} />
      </Switch>
    </UserLayout>
  );
}
